module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/kz-f528d1705766032d823749be521ec653.svg";